export default "__VITE_ASSET__BG6KHPn8__"